import React from 'react';
import * as d3 from 'd3';

const ArcText = (props) => {
  return(<path></path>)
}

export default ArcText;



// WEBPACK FOOTER //
// ./src/Charts/Chord/ArcText.js